// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const QuoteOpenSvg = ({ height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 26 23"
    role="presentation"
  >
    <path
      fill="#D0CDD0"
      fillRule="evenodd"
      d="M0 15.025c0-2.4.363-4.57 1.088-6.508.726-1.94 1.667-3.488 2.825-4.646 1.158-1.157 2.372-2.056 3.64-2.698C8.824.53 10.1.14 11.384 0v4.06c-1.813.39-3.32 1.41-4.52 3.055-1.2 1.646-1.827 3.39-1.883 5.232.42-.28.99-.42 1.716-.42 1.48 0 2.707.475 3.683 1.424.976.95 1.464 2.22 1.464 3.81 0 1.423-.537 2.636-1.61 3.64-1.075 1.005-2.408 1.507-3.998 1.507-1.786 0-3.27-.627-4.457-1.883C.592 19.17 0 17.37 0 15.024zm14 0c0-2.4.363-4.57 1.088-6.508.726-1.94 1.674-3.488 2.846-4.646 1.172-1.157 2.393-2.056 3.662-2.698C22.866.53 24.142.14 25.426 0v4.06c-1.814.39-3.328 1.41-4.54 3.055-1.215 1.646-1.85 3.39-1.906 5.232.42-.28.99-.42 1.716-.42 1.48 0 2.707.475 3.683 1.424.976.95 1.464 2.22 1.464 3.81 0 1.423-.53 2.636-1.59 3.64-1.06 1.005-2.386 1.507-3.976 1.507-1.786 0-3.28-.627-4.478-1.883-1.2-1.255-1.8-3.055-1.8-5.4z"
    />
  </svg>
);
QuoteOpenSvg.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default QuoteOpenSvg;
